import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Pick the right Bearer token for the active session. Student endpoints get
// the student JWT; everything else uses the teacher JWT. Cookies still flow
// through `withCredentials` for hosts that accept them.
api.interceptors.request.use((config) => {
  const url = (config.url || "").toString();
  const isStudent = url.startsWith("/student/") || url.startsWith("student/");
  const tokenKey = isStudent ? "sa_student_token" : "sa_token";
  const token = localStorage.getItem(tokenKey);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Single-session enforcement: when the backend rejects a request because this
// session was superseded by a newer login on another device, sign out cleanly
// (clear tokens + httpOnly cookie) and bounce to the login screen with a note.
let sessionEnding = false;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 401 && detail === "SESSION_SUPERSEDED" && !sessionEnding) {
      sessionEnding = true;
      const wasStudent = localStorage.getItem("sa_user_type") === "student";
      try {
        await fetch(`${API_BASE}/${wasStudent ? "student/auth/logout" : "auth/logout"}`, {
          method: "POST",
          credentials: "include",
        });
      } catch { /* clear client state regardless */ }
      localStorage.removeItem("sa_token");
      localStorage.removeItem("sa_student_token");
      localStorage.removeItem("sa_user_type");
      localStorage.removeItem("sa_selected_class");
      localStorage.removeItem("sa_selected_section");
      sessionStorage.setItem("sa_session_ended", "1");
      window.location.replace("/login");
      return new Promise(() => {}); // halt the rejected chain during redirect
    }
    return Promise.reject(error);
  }
);

export function apiErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
